import { firebase } from "@data/firebase/config";
import { Client, clientAddressStatus, clientReturnStatus } from "@domain/models/Client";
import { collection, onSnapshot, orderBy, query, Timestamp, where } from "firebase/firestore";
import { fireabseAdapter } from "./firebaseAdapter";
import DatabaseReturnClientRepository from "@domain/repositories/DatabaseReturnClientRepository";
import { ReturnClientStore } from "@domain/stores/ReturnClientStore";

export class FirebaseReturnClientRepository implements DatabaseReturnClientRepository {
  constructor(private readonly returnClientStore: ReturnClientStore) {}

  watchReturnClientsByDateAdmin(startDate: Timestamp, endDate: Timestamp) {
    const consulta = query(
      collection(firebase.db, "clients"),
      where("returnStatus", "in", [
        clientReturnStatus.COMPLETED,
        clientReturnStatus.PENDING,
        clientReturnStatus.PREMIUM,
        clientReturnStatus.EXPIRED,
      ]),
      where("lastReportDate", ">=", startDate),
      where("lastReportDate", "<=", endDate),
      orderBy("lastReportDate", "desc")
    );

    onSnapshot(
      consulta,
      async (querySnapshot) => {
        const mappedDocs = fireabseAdapter.mapFirebaseDoc<Client>(querySnapshot);

        const mappedReturn = fireabseAdapter.mapReturnClients(mappedDocs);

        this.returnClientStore.updateDashboardReturns(mappedReturn);
      },
      (error) => console.log("watchReturnClientsByDateAdmin error", error)
    );
  }

  watchReturnClientsByDateManager(
    startDate: Timestamp,
    endDate: Timestamp,
    operatorsIds: string[]
  ) {
    const consulta = query(
      collection(firebase.db, "clients"),
      where("returnStatus", "in", [
        clientReturnStatus.COMPLETED,
        clientReturnStatus.PENDING,
        clientReturnStatus.PREMIUM,
        clientReturnStatus.EXPIRED,
      ]),
      where("lastReportDate", ">=", startDate),
      where("lastReportDate", "<=", endDate),
      orderBy("lastReportDate", "desc")
    );

    onSnapshot(
      consulta,
      async (querySnapshot) => {
        const mappedDocs = fireabseAdapter.mapFirebaseDoc<Client>(querySnapshot);

        const mappedReturn = fireabseAdapter.mapReturnClients(
          mappedDocs.filter((x) => operatorsIds.includes(x.operatorId))
        );

        this.returnClientStore.updateDashboardReturns(mappedReturn);
      },
      (error) => console.log("watchReturnClientsByDateManager error", error)
    );
  }

  watchReturnClientsAdmin() {
    const consulta = query(
      collection(firebase.db, "clients"),
      where("returnStatus", "in", [
        clientReturnStatus.COMPLETED,
        clientReturnStatus.PENDING,
        clientReturnStatus.PREMIUM,
        clientReturnStatus.EXPIRED,
      ]),
      orderBy("lastReportDate", "desc")
    );

    onSnapshot(
      consulta,
      async (querySnapshot) => {
        const mappedDocs = fireabseAdapter.mapFirebaseDoc<Client>(querySnapshot);

        const mappedReturn = fireabseAdapter.mapReturnClients(mappedDocs);

        this.returnClientStore.updateReturns(mappedReturn);
      },
      (error) => console.log("watchReturnClientsAdmin error", error)
    );
  }

  watchReturnClientsManager(operatorsIds: string[]) {
    const consulta = query(
      collection(firebase.db, "clients"),
      where("returnStatus", "in", [
        clientReturnStatus.COMPLETED,
        clientReturnStatus.PENDING,
        clientReturnStatus.PREMIUM,
        clientReturnStatus.EXPIRED,
      ]),
      orderBy("lastReportDate", "desc")
    );

    onSnapshot(
      consulta,
      async (querySnapshot) => {
        const mappedDocs = fireabseAdapter.mapFirebaseDoc<Client>(querySnapshot);

        const mappedReturn = fireabseAdapter.mapReturnClients(
          mappedDocs.filter((x) => operatorsIds.includes(x.operatorId))
        );

        this.returnClientStore.updateReturns(mappedReturn);
      },
      (error) => console.log("watchReturnClientsManager error", error)
    );
  }

  watchReturnClientsOperator(id: string) {
    const consulta = query(
      collection(firebase.db, "clients"),
      where("addressStatus", "==", clientAddressStatus.FOUND),
      where("hasReturn", "==", true),
      where("operatorId", "==", id),
      orderBy("lastReportDate", "desc")
    );

    onSnapshot(
      consulta,
      async (querySnapshot) => {
        const mappedDocs = fireabseAdapter.mapFirebaseDoc<Client>(querySnapshot);

        const mappedReturn = fireabseAdapter.mapReturnClients(mappedDocs);

        this.returnClientStore.updateReturns(mappedReturn);
      },
      (error) => console.log("watchReturnClientsOperator error", error)
    );
  }
}
